import React, { useState, useEffect } from 'react';

const StepCard = ({ displayedNumber, icon, text, textHover, link, linkText, theme }) => {
  const [isHovered, setIsHovered] = useState(false);
  const [isLargeScreen, setIsLargeScreen] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsLargeScreen(window.innerWidth >= 1024);
    };
    
    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  const themeStyles = {
    blue: {
      background: 'bg-blue-40 dark:bg-blue-600',
      numberBubble: 'bg-blue-900 text-white shadow-md',
      numberBubbleHover: 'bg-blue-600 text-white shadow-md dark:bg-yellow-700 dark:text-blue-900',
      text: 'text-blue-900 dark:text-white',
      linkText: 'text-gray-600 hover:text-gray-800 dark:text-yellow-600 hover:dark:text-yellow-700',
      border: 'border shadow-md'
    },
    white: {
      background: 'bg-white dark:bg-blue-100',
      numberBubble: 'bg-white text-blue-500 shadow-lg',
      numberBubbleHover: 'bg-blue-600 text-white dark:bg-yellow-700 dark:text-blue-900',
      text: 'text-blue-500 dark:text-blue-900',
      linkText: 'text-gray-600 hover:text-gray-800 dark:text-gray-700 hover:dark:text-gray-900',
      border: 'border shadow-md'
    }
  };

  const currentTheme = themeStyles[theme];

  const handleCardClick = () => {
    if (link && isLargeScreen) {
      window.location.href = link;
    }
  };

  return (
    <div 
      className={`
        relative 
        flex 
        flex-col 
        p-2 
        rounded-lg 
        transition-all 
        duration-300 
        ease-in-out 
        w-[200px]
        ${isHovered ? 'h-auto' : 'h-[260px]'}
        ${currentTheme.background} 
        ${currentTheme.border}
        overflow-visible
        ${isLargeScreen ? 'cursor-pointer lg:cursor-pointer' : 'cursor-default lg:cursor-pointer'}
      `}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={handleCardClick}
    >
      {/* Number Bubble - Updated positioning */}
      <div 
        className={`
          absolute 
          -top-4 
          left-4 
          w-8 
          h-8 
          rounded-full 
          flex 
          items-center 
          justify-center 
          z-[20]
          transition-all 
          duration-500 
          ease-in-out 
          ${isHovered ? currentTheme.numberBubbleHover : currentTheme.numberBubble}
        `}
      >
        {displayedNumber != null ? displayedNumber : '-'}

      </div>

      {/* Content Container - Added pt-4 to prevent content overlap */}
      <div className="flex flex-col items-center flex-grow pt-4"> {/* Added padding-top */}
        {/* Icon */}
        <div className="mb-4">
          {icon}
        </div>

        {/* Text */}
        <div className="flex-grow flex items-center w-full px-2"> {/* Added width and padding */}
          <p 
            className={`
              text-center 
              w-full
              transition-all 
              duration-300 
              origin-top
              font-bold
              lg:text-xl
              ${currentTheme.text}
            `}
          >
            {isHovered ? textHover : text}
          </p>
        </div>

        {/* Link - only shows on hover */}
        {isHovered && (
          <div className="w-full mt-2 mb-2">
            <a 
              href={link} 
              className={`
                underline 
                text-center
                block
                ${currentTheme.linkText}
              `}
              onClick={(e) => e.stopPropagation()}
            >
              {linkText}
            </a>
          </div>
        )}
      </div>
    </div>
  );
};

export default StepCard;